<template>
  <nav role="main" :class="{ 'open': mainMenuOpen }" @click="toggleMainMenu($event)" v-show="!isPageLoading">
    <a href="javascript:;" class="nav-logo">Blomqvist Avanti</a>

    <ul class="nav-items">
      <li title="Dashboard">
        <router-link :to="{name: 'Dashboard'}" @click.native="closeMainMenu()">
          <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-dashboard"></use></svg>
          <span class="nav-item-title">Dashboard</span>
        </router-link>
      </li>

      <li title="Kunder">
        <router-link :to="{name: 'KundeList'}" @click.native="closeMainMenu()">
          <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-customers"></use></svg>
          <span class="nav-item-title">Kunder</span>
        </router-link>
      </li>

      <template v-if="hasAccess('consultant')">
        <li title="Auksjoner">
          <router-link :to="{name: 'AuctionsList'}" @click.native="closeMainMenu()">
            <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-auctions"></use></svg>
            <span class="nav-item-title">Auksjoner</span>
          </router-link>
        </li>
      </template>

      <template v-if="hasAccess('expert')">
        <li title="Rapporter">
          <router-link :to="{name: 'ReportsList'}" @click.native="closeMainMenu()">
            <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-reports"></use></svg>
            <span class="nav-item-title">Rapporter</span>
          </router-link>
        </li>
      </template>

      <li title="Ansatte" v-if="hasAccess('management')">
        <router-link :to="{name: 'BrukerList'}" @click.native="closeMainMenu()">
          <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-employees"></use></svg>
          <span class="nav-item-title">Ansatte</span>
        </router-link>
      </li>
      <li title="Innstillinger" v-if="hasAccess('admin')">
        <router-link :to="{name: 'InstillingerList' }" @click.native="closeMainMenu()">
          <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-settings"></use></svg>
          <span class="nav-item-title">Innstillinger</span>
        </router-link>
      </li>
      <li title="Verktøy" v-if="hasAccess('admin')">
        <router-link :to="{name: 'VerktoyList' }" @click.native="closeMainMenu()">
          <svg width="42px" height="49px" viewBox="0 0 42 49"><use xlink:href="/static/sprites.svg#nav-item-tools"></use></svg>
          <span class="nav-item-title">Verktøy</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainNavigation',
  data () {
    return {
      user: {},
      mainMenuOpen: false
    }
  },
  created () {
    this.user = this.getUser

    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('nav[role="main"]')

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.mainMenuOpen = false
      }
    })
  },
  computed: {
    activeRoute: function () {
      return this.$route.name
    },
    ...mapGetters(['isPageLoading', 'isLoggedIn', 'getUser'])
  },
  methods: {
    toggleMainMenu: function (event) {
      if (event.target.nodeName === 'svg' || event.target.nodeName === 'SPAN') {
        this.mainMenuOpen = false
      } else {
        this.mainMenuOpen = !this.mainMenuOpen
      }
    },
    closeMainMenu: function () {
      this.mainMenuOpen = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TheMainNavigation.vue